/**
 * 人物
 */
export enum FigureId {
    XX = 1,
    ZZ = 2,
    NQ = 3,
}

/**
 * 预约类型
 */
export enum OrderType {
    order = 1,
    invite = 2,
}

/**
 * 按钮点击类型
 */
export enum ClickType {
    XX = "xx",
    ZZ = "zz",
    NQ = "nq",
}

/**
 * 资源类型(0:其他，1：tap,2:平台手机短信，3：平台手机密码，4：平台来宾，5：平台个性邮箱)
 */
export const sourceMap = {
    "0": "",
    "1": "tap",
    "2": "web",
    "3": "web",
    "4": "hall",
    "5": "hall",
};
